
const VocabTopBar = {
    'home' : ['Inicio', 'Home'],
    'profile' : ['Perfil', 'Profile'],
    'pro_suite' : ['Suite', 'Suite'],
    'more': ['Más', 'More'],
    'configuration' : ['Configuración', 'Configuration'],
    'logout' : ['Cerrar sesión ', 'Logout'],
    'active_patient' : ['Paciente activo', 'Active patient'],
    'search' : ['🔍', '🔍'],
    'search_toolip' : ['Busqueda por nombre de usuario', 'Search by username'],
    'clear_patient' : ['Limpiar paciente', 'Clear patient'],
    'notifications': ['Notificaciones', 'Notifications'],
    'diagnosis': ['Diagnostico', 'Diagnosis'],
    'get_my_qr': ['Mi QR', 'My QR'],
  }
  export default VocabTopBar;
    